module.exports = __webpack_public_path__ + "static/img/contact1.6fde4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact1.jpg
// module id = XxWu
// module chunks = 0